import "antd/es/message/style";
import _message from "antd/es/message";
import "antd/es/grid/style";
import _Grid from "antd/es/grid";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useRef, useContext, useReducer } from 'react';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import classnames from 'classnames';
import { ArrowLeftOutlined, ArrowRightOutlined } from 'iglooicon';
import Modal from '../modal';
import Password from '../input/password';
import Button from '../button';
import { LocaleContext } from '../locale';
var useBreakpoint = _Grid.useBreakpoint;
var PasswordResponses = {
  NEED_PASSWORD: 1,
  INCORRECT_PASSWORD: 2
};

var PdfViewer = function PdfViewer(_ref) {
  var src = _ref.src,
      left = _ref.left,
      top = _ref.top,
      scale = _ref.scale,
      isCurrent = _ref.isCurrent,
      _ref$showAllPages = _ref.showAllPages,
      showAllPages = _ref$showAllPages === void 0 ? true : _ref$showAllPages;

  var _useContext = useContext(LocaleContext),
      formatMessage = _useContext.formatMessage;

  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      pageSize = _useState2[0],
      setPageSize = _useState2[1];

  var _useState3 = useState(1),
      _useState4 = _slicedToArray(_useState3, 2),
      page = _useState4[0],
      setPage = _useState4[1];

  var documentRef = useRef(null);

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      needPassword = _useState6[0],
      setNeedPassword = _useState6[1];

  var _useBreakpoint = useBreakpoint(),
      md = _useBreakpoint.md;

  var _useReducer = useReducer(function (a) {
    return a + 1;
  }, 0),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      index = _useReducer2[0],
      update = _useReducer2[1];

  var handlePageInit = function handlePageInit(document) {
    var _ref2 = document || {},
        numPages = _ref2.numPages;

    if (numPages) {
      setPageSize(numPages);
    }
  };

  var handleCancelLoad = function handleCancelLoad() {
    var current = documentRef === null || documentRef === void 0 ? void 0 : documentRef.current;

    if (current) {
      // @ts-ignore
      current.setState({
        pdf: false
      });
    }

    setNeedPassword(true);
  };

  var onPassword = function onPassword(callback, reason) {
    if (reason) {
      var password = '';

      if (reason === PasswordResponses.INCORRECT_PASSWORD) {
        _message.error(formatMessage({
          id: 'Invalid password.'
        }));
      }

      Modal.confirm({
        title: formatMessage({
          id: 'Enter the password to open this PDF file.'
        }),
        maskClosable: false,
        content: _jsx("div", {
          children: _jsx(Password, {
            onChange: function onChange(event) {
              return password = event.target.value;
            },
            placeholder: "input password"
          })
        }),
        okText: formatMessage({
          id: 'Ok'
        }),
        cancelText: formatMessage({
          id: 'Cancel'
        }),
        onOk: function onOk() {
          return callback(password);
        },
        onCancel: handleCancelLoad
      });
    }
  };

  var reopen = function reopen() {
    setNeedPassword(false);
    update();
  };

  if (needPassword) {
    return _jsx(Button, {
      onClick: reopen,
      style: {
        color: '#ffffff'
      },
      type: "text",
      children: formatMessage({
        id: 'This is an encrypted file, click to enter password.'
      })
    });
  }

  if (showAllPages) {
    return _jsx("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: "calc(100vw - ".concat(md ? 64 : 32, "px)"),
        maxHeight: '100%',
        transform: "translate(".concat(left, "px, ").concat(top, "px)"),
        position: 'absolute',
        overflow: 'auto'
      },
      children: _jsx(Document, {
        file: src,
        onLoadSuccess: handlePageInit,
        ref: documentRef,
        onPassword: onPassword,
        children: Array.from({
          length: pageSize
        }).map(function (_, index) {
          return _jsx(Page, {
            pageNumber: index + 1,
            scale: scale
          }, index);
        })
      })
    }, index);
  }

  return _jsxs(_Fragment, {
    children: [_jsx("div", {
      style: {
        maxWidth: "calc(100vw - ".concat(md ? 64 : 32, "px)"),
        maxHeight: '100%',
        transform: "translate(".concat(left, "px, ").concat(top, "px)"),
        position: 'absolute',
        overflow: 'auto'
      },
      children: _jsx(Document, {
        file: src,
        onLoadSuccess: handlePageInit,
        ref: documentRef,
        onPassword: onPassword,
        children: _jsx(Page, {
          pageNumber: page,
          scale: scale
        })
      })
    }, index), isCurrent && Boolean(pageSize > 1) && _jsxs("div", {
      style: {
        position: 'fixed',
        bottom: 0,
        right: 96,
        height: 48,
        zIndex: 2
      },
      children: [_jsx(ArrowLeftOutlined, {
        onClick: function onClick() {
          return setPage(page - 1);
        },
        className: classnames({
          'igloo-preview-page-btn': true,
          'igloo-preview-previous': true,
          'igloo-preview-disabled': page === 1
        })
      }), _jsx(ArrowRightOutlined, {
        onClick: function onClick() {
          return setPage(page + 1);
        },
        className: classnames({
          'igloo-preview-page-btn': true,
          'igloo-preview-next': true,
          'igloo-preview-disabled': page === pageSize
        })
      })]
    })]
  });
};

var MediaItem = function MediaItem(_ref3) {
  var type = _ref3.type,
      src = _ref3.src,
      scale = _ref3.scale,
      offset = _ref3.offset,
      isCurrent = _ref3.isCurrent,
      showAllPages = _ref3.showAllPages;
  var top = offset.top,
      left = offset.left;

  switch (type) {
    case 'video':
      return _jsx("video", {
        src: src,
        style: {
          maxWidth: '100%',
          maxHeight: '100%'
        },
        autoPlay: true
      });

    case 'pdf':
      return _jsx(PdfViewer, {
        src: src,
        top: top,
        left: left,
        scale: scale,
        isCurrent: isCurrent,
        showAllPages: showAllPages
      });

    default:
      return _jsx("img", {
        src: src,
        style: {
          maxWidth: '100%',
          maxHeight: '100%',
          transform: "scale(".concat(scale, ") translate(").concat(left, "px, ").concat(top, "px)"),
          position: 'absolute'
        }
      });
  }
};

var Media = function Media(_ref4) {
  var src = _ref4.src,
      className = _ref4.className,
      style = _ref4.style,
      _ref4$scale = _ref4.scale,
      scale = _ref4$scale === void 0 ? 1 : _ref4$scale,
      type = _ref4.type,
      _ref4$isCurrent = _ref4.isCurrent,
      isCurrent = _ref4$isCurrent === void 0 ? false : _ref4$isCurrent,
      _ref4$showAllPages = _ref4.showAllPages,
      showAllPages = _ref4$showAllPages === void 0 ? true : _ref4$showAllPages;

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isDrag = _useState8[0],
      setIsDrag = _useState8[1];

  var _useState9 = useState({
    startX: 0,
    startY: 0
  }),
      _useState10 = _slicedToArray(_useState9, 2),
      startPos = _useState10[0],
      setStartPos = _useState10[1];

  var _useState11 = useState({
    top: 0,
    left: 0
  }),
      _useState12 = _slicedToArray(_useState11, 2),
      offset = _useState12[0],
      setOffset = _useState12[1];

  var _useState13 = useState({
    top: 0,
    left: 0
  }),
      _useState14 = _slicedToArray(_useState13, 2),
      lastOffset = _useState14[0],
      setLastOffset = _useState14[1];

  var handleMouseUp = function handleMouseUp(e) {
    e.preventDefault();
    var button = e.button;

    if (button) {
      return;
    }

    setIsDrag(false);
    setLastOffset(_objectSpread({}, offset));
  };

  var handleMouseDown = function handleMouseDown(e) {
    e.preventDefault();
    var clientX = e.clientX,
        clientY = e.clientY,
        button = e.button;

    if (button) {
      return;
    }

    setIsDrag(true);
    setStartPos({
      startX: clientX,
      startY: clientY
    });
  };

  var handleMouseMove = function handleMouseMove(e) {
    e.preventDefault();
    if (!isDrag) return;
    var clientX = e.clientX,
        clientY = e.clientY;
    var _startPos$startX = startPos.startX,
        startX = _startPos$startX === void 0 ? 0 : _startPos$startX,
        _startPos$startY = startPos.startY,
        startY = _startPos$startY === void 0 ? 0 : _startPos$startY;
    var _lastOffset$left = lastOffset.left,
        left = _lastOffset$left === void 0 ? 0 : _lastOffset$left,
        _lastOffset$top = lastOffset.top,
        top = _lastOffset$top === void 0 ? 0 : _lastOffset$top;
    setOffset({
      left: left + clientX - startX,
      top: top + clientY - startY
    });
  };

  return _jsx("div", {
    style: {
      position: 'relative',
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'auto'
    },
    onMouseDown: handleMouseDown,
    onMouseUp: handleMouseUp,
    onMouseMove: handleMouseMove,
    children: _jsx(MediaItem, {
      type: type,
      src: src,
      scale: scale,
      offset: offset,
      isCurrent: isCurrent,
      showAllPages: showAllPages
    })
  });
};

export default Media;